import { type Mesh } from '@babylonjs/core/Meshes/mesh';
import { type TransformNode } from '@babylonjs/core/Meshes/transformNode';
import { type AssetContainer } from '@babylonjs/core/assetContainer';
import { type Nullable } from '@babylonjs/core/types';
import { type IMeshRenderableComponent, type IScene, type ISceneEntity } from '@seddi/scene';
import { type ISurfaceMaterial } from '@seddi/surface-material';
import log from 'loglevel';
import { type SurfaceMaterialLoader } from '../resources/surfaceMaterialLoader';

export class EcMeshRenderableLoader {
  private readonly surfaceMaterialLoader: SurfaceMaterialLoader;

  constructor(surfaceMaterialLoader: SurfaceMaterialLoader) {
    this.surfaceMaterialLoader = surfaceMaterialLoader;
  }

  private _assetContainer: Nullable<AssetContainer> = null;

  async loadAssetContainerAsync(
    scene: IScene,
    entity: ISceneEntity,
    parent: TransformNode,
    container: Nullable<AssetContainer> = null,
  ) {
    this._assetContainer = container;
    return this._loadAsync(scene, entity, parent);
  }

  loadAsync(scene: IScene, entity: ISceneEntity, parent: TransformNode) {
    return this._loadAsync(scene, entity, parent);
  }

  async _loadAsync(scene: IScene, entity: ISceneEntity, parent: TransformNode) {
    const babylonMeshes = parent.getChildMeshes(true);
    if (babylonMeshes.length === 0) {
      log.error(`Entity ${entity.name} has meshRenderable but no mesh component`);
      return;
    }

    // Surface material import.
    const component = entity.components.meshRenderable!;
    let material = component.material as ISurfaceMaterial;

    if (typeof material === 'string') {
      const id = component.material as string;
      material = scene.materials.find(m => m.id === id)!;
    }

    const babylonMaterial = await this.surfaceMaterialLoader.loadAsync(material);
    const babylonMesh = babylonMeshes[0] as Mesh;
    babylonMesh.material = babylonMaterial;
  }
}
